// True if `user` is granted `role`, either as their primary role or one of
// their secondaryRoles (see backend/src/models/User.js). Mirrors
// backend/src/utils/roles.js#userHasRole — use this instead of comparing
// user.role directly in ProtectedRoute, AuthContext, or any layout that
// needs to know which app shells a login can reach.
export const hasRole = (user, role) =>
  !!user && (user.role === role || (user.secondaryRoles || []).includes(role));

export default hasRole;
